import React, { FC } from 'react';
import { ReactComponent as WarningIcon } from '../../assets/icons/warning.svg';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';
import TwDialog from '../TwDialog/TwDialog';
import Stack from '@mui/material/Stack';

interface EditLoadInvoiceWarningProps {
  open: boolean;
  close: () => void;
  saveLoad: () => void;
  saveAndUpdateInvoice: () => void;
}

const TwEditLoadInvoiceWarning: FC<EditLoadInvoiceWarningProps> = ({
  open,
  close,
  saveLoad,
  saveAndUpdateInvoice
}) => {
  return (
    <TwDialog
      open={open}
      title="Updated invoice required"
      size="sm"
      onClickClose={close}
      actions={[
        <TwButton key="1" type={TwButtonType.secondary} label="Save load" action={saveLoad} />,
        <TwButton
          key="2"
          type={TwButtonType.primary}
          label="Save & update invoice"
          action={saveAndUpdateInvoice}
        />
      ]}
    >
      <Stack alignItems="center">
        <WarningIcon />
        <p className="edit-load__invoice-warning">
          An updated invoice needs to be sent out for this load. The rate information in the load
          details has been modified and no longer matches the previously sent invoice. Please send
          an updated invoices to reflect the latest rate information accurately.
        </p>
      </Stack>
    </TwDialog>
  );
};

export default TwEditLoadInvoiceWarning;
